import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'; // NB: To support unveiling e.g. <script>-tags

document.addEventListener('lazybeforesizes', (event) => {
  let parsedImageSrc

  const image = event.target
  const calculatedSizes = event.detail.width;
  const imageWidth = image.clientWidth
  let approximatedSize = Math.min(imageWidth, calculatedSizes)

  // NB: These images may not by fully visible on Desktop, so we calculate their width
  if(image.dataset.articleTeaserImageName === 'half-cinema' && window.innerWidth >= 768) {
    approximatedSize  = image.clientHeight * 1.79;
  }

  try {
    parsedImageSrc = new URL(image.dataset.src);
  } catch {
    // If there is no URL (pointing to our image proxy) we cannot set the `w`-query param
    return
  }

  let sizes = [];
  [1, 1.5, 2].forEach((dpr) => {
    const dprSize = Math.ceil(approximatedSize * dpr);
    parsedImageSrc.searchParams.set('w', dprSize)
    sizes.push(`${parsedImageSrc.toString()} ${dprSize}w`);
  });
  image.dataset.srcset = sizes.join(", ");
  event.detail.width = approximatedSize;
});
